/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type AutopilotStatusRefetchQueryVariables = {
    orgRelayId: string;
};
export type AutopilotStatusRefetchQueryResponse = {
    readonly org: {
        readonly id?: string | undefined;
        readonly orgFlowStates?: {
            readonly message?: string | null | undefined;
            readonly list?: ReadonlyArray<{
                readonly id: string;
                readonly flowKey: string | null;
                readonly current: {
                    readonly id: string;
                    readonly state: string | null;
                    readonly errorMessage: string | null;
                } | null;
            }> | undefined;
        } | null | undefined;
        readonly tailoredDefragCardSummary?: ({
            readonly __typename: "TailoredDefragCardSummary";
            readonly defragTime: unknown;
            readonly yourEventMoves: ReadonlyArray<{
                readonly event: {
                    readonly title: string | null;
                };
            }>;
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        }) | null | undefined;
        readonly " $fragmentRefs": FragmentRefs<"TailoredDefragSummaryCard_org" | "AutopilotSuggestionsCard_org">;
    } | null;
};
export type AutopilotStatusRefetchQuery = {
    readonly response: AutopilotStatusRefetchQueryResponse;
    readonly variables: AutopilotStatusRefetchQueryVariables;
};



/*
query AutopilotStatusRefetchQuery(
  $orgRelayId: ID!
) {
  org: node(id: $orgRelayId) {
    __typename
    ... on Org {
      id
      ...TailoredDefragSummaryCard_org
      ...AutopilotSuggestionsCard_org
      orgFlowStates(flowKeys: ["DefragRun"]) {
        __typename
        ... on GraphEntityError {
          message
        }
        ... on FlowStateList {
          list {
            id
            flowKey
            current {
              id
              state
              errorMessage
            }
          }
        }
      }
      tailoredDefragCardSummary {
        __typename
        ... on TailoredDefragCardSummary {
          defragTime
          yourEventMoves {
            event {
              title
            }
          }
        }
      }
    }
    id
  }
}

fragment AutopilotSuggestionEnableMeeting_autopilotMeetingKnob on AutopilotMeetingKnob {
  __typename
  knobUrn {
    id
    type
    value
  }
  externalEventId
  affectedGoals
  knobScore
}

fragment AutopilotSuggestionEnableMeeting_org on Org {
  id
  experiments
}

fragment AutopilotSuggestionEnableMeeting_referencedEvents on Event {
  title
  startTime {
    millis
  }
  endTime {
    millis
  }
  eventKey {
    externalEventId
    id
  }
  attendees {
    displayName
    profileId
    optional
    organizer
    resource
    responseStatus
    urnType
    urnValue
  }
  suggestedAutopilotSettingsResponseV3 {
    __typename
    ... on SuggestedAutopilotSettingsResponseV3 {
      intersectionOfAttendeesMeetingHours {
        minSlot {
          dayOffset
          timeSlot
        }
        maxSlot {
          dayOffset
          timeSlot
        }
      }
      calendarIdToMeetingHours {
        calendarId
        dayOffsetTimeSlotRanges {
          minSlot {
            dayOffset
            timeSlot
          }
          maxSlot {
            dayOffset
            timeSlot
          }
        }
      }
      suggestedAutopilotSettings {
        isRoomFlexible
        movementType
        allowedEndTime {
          dayOffset
          timeSlot
        }
        allowedStartTime {
          dayOffset
          timeSlot
        }
      }
    }
    ... on GraphEntityError {
      message
    }
  }
  moveRangeInLocalTimeV3 {
    __typename
    ... on MoveRangeInLocalTimeV3 {
      allowedStartTimeInclusive {
        dayOffset
        timeSlot
      }
      allowedEndTimeInclusive {
        dayOffset
        timeSlot
      }
    }
    ... on GraphEntityError {
      message
    }
  }
}

fragment AutopilotSuggestionInvite_inviteOrganizerKnob on InviteOrganizerKnob {
  __typename
  suggestedInvitee
  affectedEventIds
  affectedGoals
  knobScore
  knobUrn {
    id
    type
    value
  }
  affectedGoalsForEvents {
    externalEventId
    affectedGoals
  }
  suggestedInviteePerson {
    __typename
    ... on Person {
      primaryEmail
      profile {
        givenName
        familyName
        externalImageUrl
      }
    }
    ... on GraphEntityError {
      message
      statusCode
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment AutopilotSuggestionInvite_org on Org {
  id
}

fragment AutopilotSuggestionInvite_referencedEvents on Event {
  title
  isAllDay
  startTime {
    millis
  }
  endTime {
    millis
  }
  eventKey {
    externalEventId
    id
  }
}

fragment AutopilotSuggestionLessenConstraint_lessenAutopilotConstraintKnob on LessenAutopilotConstraintKnob {
  __typename
  knobUrn {
    id
    type
    value
  }
  externalEventId
  affectedGoals
  knobScore
}

fragment AutopilotSuggestionLessenConstraint_org on Org {
  id
}

fragment AutopilotSuggestionLessenConstraint_referencedEvents on Event {
  title
  startTime {
    millis
  }
  endTime {
    millis
  }
  eventKey {
    externalEventId
    id
  }
}

fragment AutopilotSuggestionsCard_org on Org {
  ...AutopilotSuggestionInvite_org
  ...AutopilotSuggestionEnableMeeting_org
  ...AutopilotSuggestionLessenConstraint_org
  id
  tailoredDefragCardSummary {
    __typename
    ... on TailoredDefragCardSummary {
      defragTime
      impactedOtherCalendarIds
      valueStrings
      knobs {
        inviteOrganizerKnobs {
          __typename
          knobUrn {
            id
            type
            value
          }
          ...AutopilotSuggestionInvite_inviteOrganizerKnob
        }
        autopilotMeetingKnobs {
          __typename
          knobUrn {
            id
            type
            value
          }
          ...AutopilotSuggestionEnableMeeting_autopilotMeetingKnob
        }
        lessenAutopilotConstraintKnobs {
          __typename
          knobUrn {
            id
            type
            value
          }
          ...AutopilotSuggestionLessenConstraint_lessenAutopilotConstraintKnob
        }
      }
      referencedEvents {
        ...AutopilotSuggestionInvite_referencedEvents
        ...AutopilotSuggestionEnableMeeting_referencedEvents
        ...AutopilotSuggestionLessenConstraint_referencedEvents
        eventKey {
          externalEventId
          id
        }
      }
      persons {
        __typename
        ... on PersonList {
          list {
            primaryEmail
            profile {
              givenName
              familyName
              externalImageUrl
            }
            id
          }
        }
      }
      rooms {
        __typename
        ... on RoomList {
          list {
            roomId
            name
            id
          }
        }
      }
    }
    ... on GraphEntityError {
      message
    }
  }
}

fragment AvatarPerson_org on Org {
  id
}

fragment AvatarPerson_person on Person {
  __typename
  id
  emails
  primaryEmail
  isYou
  userId
  isUser
  profile {
    givenName
    familyName
    externalImageUrl
  }
}

fragment AvatarRow_org on Org {
  ...AvatarPerson_org
}

fragment AvatarRow_personList on PersonList {
  list {
    ...AvatarPerson_person
    primaryEmail
    id
  }
}

fragment TailoredDefragSummaryAttendeeStats_org on Org {
  ...TailoredDefragSummaryAttendees_org
}

fragment TailoredDefragSummaryAttendeeStats_tailoredDefragCardSummary on TailoredDefragCardSummary {
  defragTime
  impactedOtherCalendarIds
  valueStrings
  yourEventMoves {
    newStartTime {
      dateOrDateTime
    }
    originalStartTime {
      dateOrDateTime
    }
    moveReasons
    event {
      title
      calendarIds
    }
  }
  calendarValueStrings {
    calendarId
    valueStrings
  }
  persons {
    __typename
    ... on PersonList {
      ...TailoredDefragSummaryAttendees_personList
      list {
        primaryEmail
        profile {
          givenName
          familyName
          externalImageUrl
        }
        id
      }
    }
  }
}

fragment TailoredDefragSummaryAttendees_org on Org {
  ...AvatarRow_org
}

fragment TailoredDefragSummaryAttendees_personList on PersonList {
  ...AvatarRow_personList
  list {
    primaryEmail
    profile {
      givenName
      familyName
    }
    id
  }
}

fragment TailoredDefragSummaryCard_org on Org {
  ...TailoredDefragSummaryAttendeeStats_org
  id
  tailoredDefragCardSummary {
    __typename
    ... on TailoredDefragCardSummary {
      ...TailoredDefragSummaryAttendeeStats_tailoredDefragCardSummary
      defragTime
      impactedOtherCalendarIds
      valueStrings
      yourEventMoves {
        ...TailoredDefragSummaryEventsMovedList_eventsMoved
        newStartTime {
          dateOrDateTime
        }
        originalStartTime {
          dateOrDateTime
        }
        moveReasons
        addedRooms
        removedRooms
        event {
          title
          eventKey {
            externalEventId
            id
          }
        }
      }
      persons {
        __typename
        ... on PersonList {
          list {
            primaryEmail
            profile {
              givenName
              familyName
              externalImageUrl
            }
            id
          }
        }
      }
      rooms {
        __typename
        ... on RoomList {
          ...TailoredDefragSummaryEventsMovedList_rooms
          list {
            roomId
            name
            id
          }
        }
      }
    }
    ... on GraphEntityError {
      message
    }
  }
}

fragment TailoredDefragSummaryEventMoved_eventMoved on DefragExplainedMove {
  originalStartTime {
    millis
  }
  newStartTime {
    millis
  }
  moveReasons
  addedRooms
  removedRooms
  event {
    title
    startTime {
      millis
    }
    endTime {
      millis
    }
    eventKey {
      externalEventId
      id
    }
  }
}

fragment TailoredDefragSummaryEventMoved_rooms on RoomList {
  list {
    roomId
    name
    id
  }
}

fragment TailoredDefragSummaryEventsMovedList_eventsMoved on DefragExplainedMove {
  ...TailoredDefragSummaryEventMoved_eventMoved
}

fragment TailoredDefragSummaryEventsMovedList_rooms on RoomList {
  ...TailoredDefragSummaryEventMoved_rooms
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "orgRelayId"
        } as any
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "orgRelayId"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v3 = [
        {
            "kind": "Literal",
            "name": "flowKeys",
            "value": [
                "DefragRun"
            ]
        } as any
    ], v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v5 = {
        "kind": "InlineFragment",
        "selections": [
            (v4 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "FlowState",
                "kind": "LinkedField",
                "name": "list",
                "plural": true,
                "selections": [
                    (v2 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "flowKey",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "FlowStatus",
                        "kind": "LinkedField",
                        "name": "current",
                        "plural": false,
                        "selections": [
                            (v2 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "state",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "errorMessage",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "FlowStateList",
        "abstractKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "defragTime",
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
    } as any, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "valueStrings",
        "storageKey": null
    } as any, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "millis",
        "storageKey": null
    } as any, v12 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dateOrDateTime",
            "storageKey": null
        } as any,
        (v11 /*: any*/)
    ], v13 = [
        (v11 /*: any*/)
    ], v14 = {
        "alias": null,
        "args": null,
        "concreteType": "EventTime",
        "kind": "LinkedField",
        "name": "startTime",
        "plural": false,
        "selections": (v13 /*: any*/),
        "storageKey": null
    } as any, v15 = {
        "alias": null,
        "args": null,
        "concreteType": "EventTime",
        "kind": "LinkedField",
        "name": "endTime",
        "plural": false,
        "selections": (v13 /*: any*/),
        "storageKey": null
    } as any, v16 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "externalEventId",
        "storageKey": null
    } as any, v17 = {
        "alias": null,
        "args": null,
        "concreteType": "EventKey",
        "kind": "LinkedField",
        "name": "eventKey",
        "plural": false,
        "selections": [
            (v16 /*: any*/),
            (v2 /*: any*/)
        ],
        "storageKey": null
    } as any, v18 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "calendarId",
        "storageKey": null
    } as any, v19 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primaryEmail",
        "storageKey": null
    } as any, v20 = {
        "alias": null,
        "args": null,
        "concreteType": "UserProfile",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "givenName",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "familyName",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "externalImageUrl",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v21 = {
        "alias": null,
        "args": null,
        "concreteType": "Urn",
        "kind": "LinkedField",
        "name": "knobUrn",
        "plural": false,
        "selections": [
            (v2 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v22 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "affectedGoals",
        "storageKey": null
    } as any, v23 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "knobScore",
        "storageKey": null
    } as any, v24 = [
        (v7 /*: any*/),
        (v21 /*: any*/),
        (v16 /*: any*/),
        (v22 /*: any*/),
        (v23 /*: any*/)
    ], v25 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dayOffset",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeSlot",
            "storageKey": null
        } as any
    ], v26 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "DayOffsetTimeSlot",
            "kind": "LinkedField",
            "name": "minSlot",
            "plural": false,
            "selections": (v25 /*: any*/),
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "concreteType": "DayOffsetTimeSlot",
            "kind": "LinkedField",
            "name": "maxSlot",
            "plural": false,
            "selections": (v25 /*: any*/),
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "AutopilotStatusRefetchQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                (v2 /*: any*/),
                                {
                                    "alias": null,
                                    "args": (v3 /*: any*/),
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "orgFlowStates",
                                    "plural": false,
                                    "selections": [
                                        (v5 /*: any*/),
                                        (v6 /*: any*/)
                                    ],
                                    "storageKey": "orgFlowStates(flowKeys:[\"DefragRun\"])"
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "tailoredDefragCardSummary",
                                    "plural": false,
                                    "selections": [
                                        (v7 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v8 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "DefragExplainedMove",
                                                    "kind": "LinkedField",
                                                    "name": "yourEventMoves",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Event",
                                                            "kind": "LinkedField",
                                                            "name": "event",
                                                            "plural": false,
                                                            "selections": [
                                                                (v9 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "TailoredDefragCardSummary",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "TailoredDefragSummaryCard_org"
                                },
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "AutopilotSuggestionsCard_org"
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "AutopilotStatusRefetchQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v7 /*: any*/),
                        (v2 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "tailoredDefragCardSummary",
                                    "plural": false,
                                    "selections": [
                                        (v7 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v8 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "impactedOtherCalendarIds",
                                                    "storageKey": null
                                                },
                                                (v10 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "DefragExplainedMove",
                                                    "kind": "LinkedField",
                                                    "name": "yourEventMoves",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "EventTime",
                                                            "kind": "LinkedField",
                                                            "name": "newStartTime",
                                                            "plural": false,
                                                            "selections": (v12 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "EventTime",
                                                            "kind": "LinkedField",
                                                            "name": "originalStartTime",
                                                            "plural": false,
                                                            "selections": (v12 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "moveReasons",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Event",
                                                            "kind": "LinkedField",
                                                            "name": "event",
                                                            "plural": false,
                                                            "selections": [
                                                                (v9 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "calendarIds",
                                                                    "storageKey": null
                                                                },
                                                                (v14 /*: any*/),
                                                                (v15 /*: any*/),
                                                                (v17 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "addedRooms",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "removedRooms",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "TailoredDefragCalendarValueStrings",
                                                    "kind": "LinkedField",
                                                    "name": "calendarValueStrings",
                                                    "plural": true,
                                                    "selections": [
                                                        (v18 /*: any*/),
                                                        (v10 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "persons",
                                                    "plural": false,
                                                    "selections": [
                                                        (v7 /*: any*/),
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Person",
                                                                    "kind": "LinkedField",
                                                                    "name": "list",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        (v7 /*: any*/),
                                                                        (v2 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "emails",
                                                                            "storageKey": null
                                                                        },
                                                                        (v19 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "isYou",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "userId",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "isUser",
                                                                            "storageKey": null
                                                                        },
                                                                        (v20 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "type": "PersonList",
                                                            "abstractKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "rooms",
                                                    "plural": false,
                                                    "selections": [
                                                        (v7 /*: any*/),
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Room",
                                                                    "kind": "LinkedField",
                                                                    "name": "list",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "roomId",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "name",
                                                                            "storageKey": null
                                                                        },
                                                                        (v2 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "type": "RoomList",
                                                            "abstractKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "DefragValueKnobs",
                                                    "kind": "LinkedField",
                                                    "name": "knobs",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "InviteOrganizerKnob",
                                                            "kind": "LinkedField",
                                                            "name": "inviteOrganizerKnobs",
                                                            "plural": true,
                                                            "selections": [
                                                                (v7 /*: any*/),
                                                                (v21 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "suggestedInvitee",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "affectedEventIds",
                                                                    "storageKey": null
                                                                },
                                                                (v22 /*: any*/),
                                                                (v23 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "AffectedGoalForEvent",
                                                                    "kind": "LinkedField",
                                                                    "name": "affectedGoalsForEvents",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        (v16 /*: any*/),
                                                                        (v22 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": null,
                                                                    "kind": "LinkedField",
                                                                    "name": "suggestedInviteePerson",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v7 /*: any*/),
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                (v19 /*: any*/),
                                                                                (v20 /*: any*/)
                                                                            ],
                                                                            "type": "Person",
                                                                            "abstractKey": null
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                (v4 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "statusCode",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "type": "GraphEntityError",
                                                                            "abstractKey": null
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                (v2 /*: any*/)
                                                                            ],
                                                                            "type": "Node",
                                                                            "abstractKey": "__isNode"
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "AutopilotMeetingKnob",
                                                            "kind": "LinkedField",
                                                            "name": "autopilotMeetingKnobs",
                                                            "plural": true,
                                                            "selections": (v24 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "LessenAutopilotConstraintKnob",
                                                            "kind": "LinkedField",
                                                            "name": "lessenAutopilotConstraintKnobs",
                                                            "plural": true,
                                                            "selections": (v24 /*: any*/),
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Event",
                                                    "kind": "LinkedField",
                                                    "name": "referencedEvents",
                                                    "plural": true,
                                                    "selections": [
                                                        (v9 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "isAllDay",
                                                            "storageKey": null
                                                        },
                                                        (v14 /*: any*/),
                                                        (v15 /*: any*/),
                                                        (v17 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Attendee",
                                                            "kind": "LinkedField",
                                                            "name": "attendees",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "displayName",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "profileId",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "optional",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "organizer",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "resource",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "responseStatus",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "urnType",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "urnValue",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "suggestedAutopilotSettingsResponseV3",
                                                            "plural": false,
                                                            "selections": [
                                                                (v7 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "DayOffsetTimeSlotRange",
                                                                            "kind": "LinkedField",
                                                                            "name": "intersectionOfAttendeesMeetingHours",
                                                                            "plural": false,
                                                                            "selections": (v26 /*: any*/),
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "SuggestedAutotpilotSettingsResponseV3CalendarIdMeetingHours",
                                                                            "kind": "LinkedField",
                                                                            "name": "calendarIdToMeetingHours",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v18 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "DayOffsetTimeSlotRange",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "dayOffsetTimeSlotRanges",
                                                                                    "plural": true,
                                                                                    "selections": (v26 /*: any*/),
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "SuggestedAutopilotSettingsV3",
                                                                            "kind": "LinkedField",
                                                                            "name": "suggestedAutopilotSettings",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isRoomFlexible",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "movementType",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "DayOffsetTimeSlot",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "allowedEndTime",
                                                                                    "plural": false,
                                                                                    "selections": (v25 /*: any*/),
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "DayOffsetTimeSlot",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "allowedStartTime",
                                                                                    "plural": false,
                                                                                    "selections": (v25 /*: any*/),
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "SuggestedAutopilotSettingsResponseV3",
                                                                    "abstractKey": null
                                                                },
                                                                (v5 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "moveRangeInLocalTimeV3",
                                                            "plural": false,
                                                            "selections": [
                                                                (v7 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "DayOffsetTimeSlot",
                                                                            "kind": "LinkedField",
                                                                            "name": "allowedStartTimeInclusive",
                                                                            "plural": false,
                                                                            "selections": (v25 /*: any*/),
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "DayOffsetTimeSlot",
                                                                            "kind": "LinkedField",
                                                                            "name": "allowedEndTimeInclusive",
                                                                            "plural": false,
                                                                            "selections": (v25 /*: any*/),
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "MoveRangeInLocalTimeV3",
                                                                    "abstractKey": null
                                                                },
                                                                (v5 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "TailoredDefragCardSummary",
                                            "abstractKey": null
                                        },
                                        (v5 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "experiments",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": (v3 /*: any*/),
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "orgFlowStates",
                                    "plural": false,
                                    "selections": [
                                        (v7 /*: any*/),
                                        (v5 /*: any*/),
                                        (v6 /*: any*/)
                                    ],
                                    "storageKey": "orgFlowStates(flowKeys:[\"DefragRun\"])"
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "6b607c41d2549d69281923a399f7e1fd",
            "id": null,
            "metadata": {},
            "name": "AutopilotStatusRefetchQuery",
            "operationKind": "query",
            "text": "query AutopilotStatusRefetchQuery(\n  $orgRelayId: ID!\n) {\n  org: node(id: $orgRelayId) {\n    __typename\n    ... on Org {\n      id\n      ...TailoredDefragSummaryCard_org\n      ...AutopilotSuggestionsCard_org\n      orgFlowStates(flowKeys: [\"DefragRun\"]) {\n        __typename\n        ... on GraphEntityError {\n          message\n        }\n        ... on FlowStateList {\n          list {\n            id\n            flowKey\n            current {\n              id\n              state\n              errorMessage\n            }\n          }\n        }\n      }\n      tailoredDefragCardSummary {\n        __typename\n        ... on TailoredDefragCardSummary {\n          defragTime\n          yourEventMoves {\n            event {\n              title\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment AutopilotSuggestionEnableMeeting_autopilotMeetingKnob on AutopilotMeetingKnob {\n  __typename\n  knobUrn {\n    id\n    type\n    value\n  }\n  externalEventId\n  affectedGoals\n  knobScore\n}\n\nfragment AutopilotSuggestionEnableMeeting_org on Org {\n  id\n  experiments\n}\n\nfragment AutopilotSuggestionEnableMeeting_referencedEvents on Event {\n  title\n  startTime {\n    millis\n  }\n  endTime {\n    millis\n  }\n  eventKey {\n    externalEventId\n    id\n  }\n  attendees {\n    displayName\n    profileId\n    optional\n    organizer\n    resource\n    responseStatus\n    urnType\n    urnValue\n  }\n  suggestedAutopilotSettingsResponseV3 {\n    __typename\n    ... on SuggestedAutopilotSettingsResponseV3 {\n      intersectionOfAttendeesMeetingHours {\n        minSlot {\n          dayOffset\n          timeSlot\n        }\n        maxSlot {\n          dayOffset\n          timeSlot\n        }\n      }\n      calendarIdToMeetingHours {\n        calendarId\n        dayOffsetTimeSlotRanges {\n          minSlot {\n            dayOffset\n            timeSlot\n          }\n          maxSlot {\n            dayOffset\n            timeSlot\n          }\n        }\n      }\n      suggestedAutopilotSettings {\n        isRoomFlexible\n        movementType\n        allowedEndTime {\n          dayOffset\n          timeSlot\n        }\n        allowedStartTime {\n          dayOffset\n          timeSlot\n        }\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n  moveRangeInLocalTimeV3 {\n    __typename\n    ... on MoveRangeInLocalTimeV3 {\n      allowedStartTimeInclusive {\n        dayOffset\n        timeSlot\n      }\n      allowedEndTimeInclusive {\n        dayOffset\n        timeSlot\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n}\n\nfragment AutopilotSuggestionInvite_inviteOrganizerKnob on InviteOrganizerKnob {\n  __typename\n  suggestedInvitee\n  affectedEventIds\n  affectedGoals\n  knobScore\n  knobUrn {\n    id\n    type\n    value\n  }\n  affectedGoalsForEvents {\n    externalEventId\n    affectedGoals\n  }\n  suggestedInviteePerson {\n    __typename\n    ... on Person {\n      primaryEmail\n      profile {\n        givenName\n        familyName\n        externalImageUrl\n      }\n    }\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment AutopilotSuggestionInvite_org on Org {\n  id\n}\n\nfragment AutopilotSuggestionInvite_referencedEvents on Event {\n  title\n  isAllDay\n  startTime {\n    millis\n  }\n  endTime {\n    millis\n  }\n  eventKey {\n    externalEventId\n    id\n  }\n}\n\nfragment AutopilotSuggestionLessenConstraint_lessenAutopilotConstraintKnob on LessenAutopilotConstraintKnob {\n  __typename\n  knobUrn {\n    id\n    type\n    value\n  }\n  externalEventId\n  affectedGoals\n  knobScore\n}\n\nfragment AutopilotSuggestionLessenConstraint_org on Org {\n  id\n}\n\nfragment AutopilotSuggestionLessenConstraint_referencedEvents on Event {\n  title\n  startTime {\n    millis\n  }\n  endTime {\n    millis\n  }\n  eventKey {\n    externalEventId\n    id\n  }\n}\n\nfragment AutopilotSuggestionsCard_org on Org {\n  ...AutopilotSuggestionInvite_org\n  ...AutopilotSuggestionEnableMeeting_org\n  ...AutopilotSuggestionLessenConstraint_org\n  id\n  tailoredDefragCardSummary {\n    __typename\n    ... on TailoredDefragCardSummary {\n      defragTime\n      impactedOtherCalendarIds\n      valueStrings\n      knobs {\n        inviteOrganizerKnobs {\n          __typename\n          knobUrn {\n            id\n            type\n            value\n          }\n          ...AutopilotSuggestionInvite_inviteOrganizerKnob\n        }\n        autopilotMeetingKnobs {\n          __typename\n          knobUrn {\n            id\n            type\n            value\n          }\n          ...AutopilotSuggestionEnableMeeting_autopilotMeetingKnob\n        }\n        lessenAutopilotConstraintKnobs {\n          __typename\n          knobUrn {\n            id\n            type\n            value\n          }\n          ...AutopilotSuggestionLessenConstraint_lessenAutopilotConstraintKnob\n        }\n      }\n      referencedEvents {\n        ...AutopilotSuggestionInvite_referencedEvents\n        ...AutopilotSuggestionEnableMeeting_referencedEvents\n        ...AutopilotSuggestionLessenConstraint_referencedEvents\n        eventKey {\n          externalEventId\n          id\n        }\n      }\n      persons {\n        __typename\n        ... on PersonList {\n          list {\n            primaryEmail\n            profile {\n              givenName\n              familyName\n              externalImageUrl\n            }\n            id\n          }\n        }\n      }\n      rooms {\n        __typename\n        ... on RoomList {\n          list {\n            roomId\n            name\n            id\n          }\n        }\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n}\n\nfragment AvatarPerson_org on Org {\n  id\n}\n\nfragment AvatarPerson_person on Person {\n  __typename\n  id\n  emails\n  primaryEmail\n  isYou\n  userId\n  isUser\n  profile {\n    givenName\n    familyName\n    externalImageUrl\n  }\n}\n\nfragment AvatarRow_org on Org {\n  ...AvatarPerson_org\n}\n\nfragment AvatarRow_personList on PersonList {\n  list {\n    ...AvatarPerson_person\n    primaryEmail\n    id\n  }\n}\n\nfragment TailoredDefragSummaryAttendeeStats_org on Org {\n  ...TailoredDefragSummaryAttendees_org\n}\n\nfragment TailoredDefragSummaryAttendeeStats_tailoredDefragCardSummary on TailoredDefragCardSummary {\n  defragTime\n  impactedOtherCalendarIds\n  valueStrings\n  yourEventMoves {\n    newStartTime {\n      dateOrDateTime\n    }\n    originalStartTime {\n      dateOrDateTime\n    }\n    moveReasons\n    event {\n      title\n      calendarIds\n    }\n  }\n  calendarValueStrings {\n    calendarId\n    valueStrings\n  }\n  persons {\n    __typename\n    ... on PersonList {\n      ...TailoredDefragSummaryAttendees_personList\n      list {\n        primaryEmail\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment TailoredDefragSummaryAttendees_org on Org {\n  ...AvatarRow_org\n}\n\nfragment TailoredDefragSummaryAttendees_personList on PersonList {\n  ...AvatarRow_personList\n  list {\n    primaryEmail\n    profile {\n      givenName\n      familyName\n    }\n    id\n  }\n}\n\nfragment TailoredDefragSummaryCard_org on Org {\n  ...TailoredDefragSummaryAttendeeStats_org\n  id\n  tailoredDefragCardSummary {\n    __typename\n    ... on TailoredDefragCardSummary {\n      ...TailoredDefragSummaryAttendeeStats_tailoredDefragCardSummary\n      defragTime\n      impactedOtherCalendarIds\n      valueStrings\n      yourEventMoves {\n        ...TailoredDefragSummaryEventsMovedList_eventsMoved\n        newStartTime {\n          dateOrDateTime\n        }\n        originalStartTime {\n          dateOrDateTime\n        }\n        moveReasons\n        addedRooms\n        removedRooms\n        event {\n          title\n          eventKey {\n            externalEventId\n            id\n          }\n        }\n      }\n      persons {\n        __typename\n        ... on PersonList {\n          list {\n            primaryEmail\n            profile {\n              givenName\n              familyName\n              externalImageUrl\n            }\n            id\n          }\n        }\n      }\n      rooms {\n        __typename\n        ... on RoomList {\n          ...TailoredDefragSummaryEventsMovedList_rooms\n          list {\n            roomId\n            name\n            id\n          }\n        }\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n}\n\nfragment TailoredDefragSummaryEventMoved_eventMoved on DefragExplainedMove {\n  originalStartTime {\n    millis\n  }\n  newStartTime {\n    millis\n  }\n  moveReasons\n  addedRooms\n  removedRooms\n  event {\n    title\n    startTime {\n      millis\n    }\n    endTime {\n      millis\n    }\n    eventKey {\n      externalEventId\n      id\n    }\n  }\n}\n\nfragment TailoredDefragSummaryEventMoved_rooms on RoomList {\n  list {\n    roomId\n    name\n    id\n  }\n}\n\nfragment TailoredDefragSummaryEventsMovedList_eventsMoved on DefragExplainedMove {\n  ...TailoredDefragSummaryEventMoved_eventMoved\n}\n\nfragment TailoredDefragSummaryEventsMovedList_rooms on RoomList {\n  ...TailoredDefragSummaryEventMoved_rooms\n}\n"
        }
    } as any;
})();
(node as any).hash = 'f3241f5e0b525dff508c2d6467da037e';
export default node;
